import React, { Component } from 'react';
import { node, string } from 'prop-types';
import { UTLabel } from '@widergy/energy-ui';

import { appConfig } from 'config/customization';
import UTOpenableRow from 'app/components/UTOpenableRow';
import { message } from 'utils/stringUtils';
import Images from 'config/assets';

import styles from './styles';

class ConfigurationOpenableRow extends Component {
  state = {
    active: false
  };

  handleRowClick = () => this.setState({ active: !this.state.active });

  handleRenderComponent = () => {
    const { Icon } = this.props;
    return (
      <div
        onClick={this.handleRowClick}
        role="presentation"
        style={[
          styles.changePasswordField,
          styles.configurationField,
          this.state.active ? styles.changePasswordActive : this.props.style
        ]}
      >
        <div style={styles.iconAndTitleContainer}>
          {appConfig.userDataManagement.rowDescIcons && (
            <div style={styles.icons}>{Icon && <Icon color={this.props.iconColor} />}</div>
          )}
          <UTLabel semibold>{this.props.title}</UTLabel>
        </div>
        <span style={styles.passwordContainer}>
          <UTLabel extrabold small>
            {!this.state.active ? message('Configuration:change') : message('Configuration:close')}
          </UTLabel>
          <img
            style={styles.arrow}
            src={this.state.active ? Images.listArrowUp : Images.listArrowDown}
            alt=""
          />
        </span>
      </div>
    );
  };

  handleRenderActiveComponent = () => <div style={styles.formContainer}>{this.props.children}</div>;

  render() {
    return (
      <UTOpenableRow
        style={this.state.active ? styles.active : styles.inactive}
        active={this.state.active}
        renderComponent={this.handleRenderComponent}
        renderActiveComponent={this.handleRenderActiveComponent}
      />
    );
  }
}

ConfigurationOpenableRow.propTypes = {
  title: string.isRequired,
  Icon: node,
  iconColor: string
};

export default ConfigurationOpenableRow;
